module.exports = __webpack_public_path__ + "img/bg_tech_electronics@2x.5bb86593.jpg";